/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-history.reducer';

export const TreatmentHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentHistoryEntity = useAppSelector(state => state.treatmentHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentHistoryDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentHistory.detail.title">TreatmentHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentHistory.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentHistoryEntity.id}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentHistory.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentHistoryEntity.cursor}</dd>
          <dt>
            <span id="diagnose">
              <Translate contentKey="tinyMedicRestApp.treatmentHistory.diagnose">Diagnose</Translate>
            </span>
          </dt>
          <dd>{treatmentHistoryEntity.diagnose}</dd>
          <dt>
            <span id="diagnoseNotes">
              <Translate contentKey="tinyMedicRestApp.treatmentHistory.diagnoseNotes">Diagnose Notes</Translate>
            </span>
          </dt>
          <dd>{treatmentHistoryEntity.diagnoseNotes}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.treatmentHistory.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{treatmentHistoryEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.treatmentHistory.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{treatmentHistoryEntity.endDate}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.treatmentHistory.status">Status</Translate>
            </span>
          </dt>
          <dd>{treatmentHistoryEntity.status}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentHistory.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentHistoryEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.treatmentHistory.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{treatmentHistoryEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.treatmentHistory.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{treatmentHistoryEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentHistory.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentHistoryEntity.microSec}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentHistory.consultant">Consultant</Translate>
          </dt>
          <dd>{treatmentHistoryEntity.consultant ? treatmentHistoryEntity.consultant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentHistory.patient">Patient</Translate>
          </dt>
          <dd>{treatmentHistoryEntity.patient ? treatmentHistoryEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentHistory.prescription">Prescription</Translate>
          </dt>
          <dd>{treatmentHistoryEntity.prescription ? treatmentHistoryEntity.prescription.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-history/${treatmentHistoryEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentHistoryDetail;
